module.exports = __webpack_public_path__ + "static/media/dongfeng.65e7c2c1.png";